module.exports = __webpack_public_path__ + "img/request-upgrade.810e397e.svg";